import createModule from "../createModule"
import { getToken, getValidToken, getUserName, getUserEmail, getSsoActivationToken } from "./selectors"
import view from "./view"
import { Creators as LoginCreators } from "modules/login/model"
import withUrlParams from "hocs/withUrlParams"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    queryToken: getToken(state, props),
  }),
  data: [{
    resource: "activateAccountUser",
    as: null,
    noToken: true,
    url: ({ queryToken }) => `/api/users/reset-password/${queryToken}`,
  }],
  mapStateToProps: (state, props) => ({
    ssoActivationToken: getSsoActivationToken(state, props),
    token: getValidToken(state, props),
    name: getUserName(state),
    email: getUserEmail(state),
  }),
  actions: {
    setLoginError: LoginCreators.setErrorMessage,
  },
}))
